import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { fetchClient, userApiClient } from '@/setup/api'

export const getRestaurantQueryOptions = (restaurantSlug: string, locale: string) => {
    const init = {
        params: { path: { restaurantSlug } },
        headers: { 'accept-language': locale },
    }

    return {
        queryKey: userApiClient.queryOptions('get', '/web/restaurants/{restaurantSlug}', init)
            .queryKey,
        queryFn: async ({ signal }: { signal: AbortSignal }) => {
            const { data, error, response } = await fetchClient.GET(
                '/web/restaurants/{restaurantSlug}',
                { ...init, signal }
            )

            if (response.status === 404) return null
            if (error) throw error

            return data ?? null
        },
    }
}

export function useGetRestaurantQuery(restaurantSlug: string) {
    const locale = useLocale()

    return useQuery(getRestaurantQueryOptions(restaurantSlug, locale))
}
